/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_GuestsInputs */

const en_verify_guests = /** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests`)
};

const es_verify_guests = /** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitados`)
};

const fr_verify_guests = /** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invités`)
};

const de_verify_guests = /** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste`)
};

const id_verify_guests = /** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamu`)
};

/** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */
const ja_verify_guests = en_verify_guests;

/** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */
const zh_verify_guests = en_verify_guests;

/** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */
const ar_verify_guests = en_verify_guests;

/** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */
const it_verify_guests = en_verify_guests;

/** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */
const ru_verify_guests = en_verify_guests;

/** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */
const pt_verify_guests = en_verify_guests;

/** @type {(inputs: Verify_GuestsInputs) => LocalizedString} */
const ko_verify_guests = en_verify_guests;

/**
* | output |
* | --- |
* | "Guests" |
*
* @param {Verify_GuestsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_guests = /** @type {((inputs?: Verify_GuestsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_GuestsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_guests(inputs)
	if (locale === "es") return es_verify_guests(inputs)
	if (locale === "fr") return fr_verify_guests(inputs)
	if (locale === "de") return de_verify_guests(inputs)
	if (locale === "ja") return ja_verify_guests(inputs)
	if (locale === "zh") return zh_verify_guests(inputs)
	if (locale === "ar") return ar_verify_guests(inputs)
	if (locale === "id") return id_verify_guests(inputs)
	if (locale === "it") return it_verify_guests(inputs)
	if (locale === "ru") return ru_verify_guests(inputs)
	if (locale === "pt") return pt_verify_guests(inputs)
	return ko_verify_guests(inputs)
});